import script from "./photo_input_block.vue?vue&type=script&setup=true&lang=js"
export * from "./photo_input_block.vue?vue&type=script&setup=true&lang=js"

import "./photo_input_block.vue?vue&type=style&index=0&id=142b29a4&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142b29a4"]])

export default __exports__